import React from "react";
import { Container } from "./styles";

import casas from "../../assets/casas.png";
import posicionando from "../../assets/posicionando.png";
import modos from "../../assets/modos.png";

function Guide({ mode, setMode, hide }) {
  let guideMode = mode;

  return (
    <Container>
      {guideMode === "short" ? (
        <>
          <h3>Como completar esta atividade?</h3>
          <p>Cada uma das casas representa um número</p>
          <img src={casas} alt="" srcSet="" className="casas" width={500} />
          <p>
            Os números serão sorteados, <br />
            sua tarefa é colocar cada um deles em seu devido lugar
          </p>
          <img
            src={posicionando}
            alt=""
            srcSet=""
            className="casas"
            width={500}
          />

          <div className="buttons">
            <button className="primary" onClick={hide}>
              Iniciar a atividade!
            </button>
            <button className="secondary" onClick={() => setMode("full")}>
              Ler mais sobre o<br />
              Método Líquen
            </button>
          </div>
        </>
      ) : (
        <>
          <p>
            O Tabuleiro Líquen é um material didático, apresentado nos modelos
            virtual e físico.
          </p>
          <p>
            O objetivo do Tabuleiro Líquen é construir a sequência numérica e
            compreender o sistema de numeração decimal, quem são os
            antecessores, sucessores, assim como os padrões nas linhas e
            colunas.
          </p>
          <p>
            Ele é composto por uma tabela formada por 10 linhas e 10 colunas, e
            peças numeradas de 1 a 100. Para o preenchimento você pode escolher
            a quantidade de linhas, definindo o tamanho do Tabuleiro Líquen que
            pode variar de 10 até 100 peças.
          </p>
          <p>
            A primeira linha inicia com o número 1 e acaba no 10, a segunda
            linha inicia no 11 e acaba no 20, e assim por diante, para que o
            aluno entenda a sequência completando as dezenas.
          </p>
          <p>
            O Tabuleiro Líquen apresenta dois modos, em um deles as casas estão
            numeradas e no outro as casas estão vazias. Você pode escolher. Para
            entender a sequência, sugerimos preencher primeiro a modo numerado
            do Tabuleiro Líquen.
          </p>
          <div className="center">
            <img src={modos} alt="" srcSet="" width="600" />
          </div>
          <p>
            No Tabuleiro Líquen digital, a primeira ação é escolher o tamanho do
            Tabuleiro Líquen e o modo de apresentação, numerado ou não. Ao
            iniciar a atividade o computador fará um sorteio, o número deve ser
            arrastado até sua posição correta. Aqueles números que forem
            colocados no lugar errado aparecem em outra cor e podem ser
            reposicionados.
          </p>
          <p>
            Quando todas as peças estiverem posicionadas corretamente, o
            tabuleiro finaliza e informa o tempo demandado para seu
            preenchimento.
          </p>
          <p>
            A evolução pode ser observada na diminuição do tempo, sendo ideal
            alcançar um tempo mínimo de 2 minutos.
          </p>
          <div className="buttons">
            <button className="primary" onClick={hide}>
              Iniciar a atividade!
            </button>
          </div>
        </>
      )}
    </Container>
  );
}

export default Guide;
